export const AppPreference = {
  CookiesConsent: 'cookiesConsent',
};